"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgramDetailsBanner = exports.ProgramDetailsBannerDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var entity_details_banner_1 = require("./entity-details-banner");
// import { Button } from '../elements/button';
var entity_stack_badge_1 = require("./entity-stack-badge");
var ui_1 = require("@shapeable/ui");
var use_lang_1 = require("../../hooks/use-lang");
exports.ProgramDetailsBannerDefaultProps = {
  buttonColors: {
    text: 'text',
    border: 'text',
    fill: 'text',
    hover: {
      text: 'text-mid',
      border: 'text-mid',
      fill: 'text-mid'
    }
  }
};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(8))
});
var RegisterButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    max-width: 250px;\n  "], ["\n    max-width: 250px;\n  "])))
});
var ParticipantsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding-top: ", ";\n  "], ["\n    padding-top: ", ";\n  "])), theme_1.theme.UNIT(4))
});
// -------- Components -------->
var My = {
  Container: (0, styled_components_1.default)(entity_details_banner_1.EntityDetailsBanner)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  RegisterButton: (0, styled_components_1.default)(ui_1.Button)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), RegisterButtonStyles),
  Participants: (0, styled_components_1.default)(entity_stack_badge_1.EntityStackBadge)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ParticipantsStyles)
};
var ProgramDetailsBanner = function (props) {
  var className = props.className,
    entity = props.entity,
    buttonColors = props.buttonColors;
  var t = (0, use_lang_1.useLang)();
  var _a = entity.participants,
    participants = _a === void 0 ? [] : _a,
    registrationUrl = entity.registrationUrl,
    isCurrentUserParticipating = entity.isCurrentUserParticipating;
  var hasParticipants = !!participants.length;
  var registerButtonOnClick = function () {
    if (!registrationUrl) return;
    window.open(registrationUrl, '_blank');
  };
  return react_1.default.createElement(My.Container, {
    entity: entity,
    size: "large",
    entityTypeName: "Program",
    showSlug: false,
    showBadge: false,
    showFollowControls: false
  }, hasParticipants && react_1.default.createElement(My.Participants, {
    items: participants,
    singleLabel: 'Participant',
    multipleLabel: 'Participants',
    hasBadge: isCurrentUserParticipating,
    badgeLabel: isCurrentUserParticipating ? 'Participating' : ''
  }));
};
exports.ProgramDetailsBanner = ProgramDetailsBanner;
exports.ProgramDetailsBanner.defaultProps = exports.ProgramDetailsBannerDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;